module.exports = __webpack_public_path__ + "img/crypt.8f1e2b90.svg";